import React, { useEffect, useState } from 'react';
import '../custom.css'
import {
    Table
} from "reactstrap";

import { ProgressBar } from 'primereact/progressbar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { DateInput } from './DateInput'
import '../css/sgHole.css'
import { RoundTypeDropdown } from './dropdowns/RoundTypeDropdown';
import RoundTable from './RoundTable';
import { MultiSelectPlayers } from './dropdowns/MultiSelectPlayers';
import { useAuth } from './appwrite-testing/AuthContext';
const ToDateRounds = () => {
    const { getJWT } = useAuth();
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [roundType, setRoundType] = useState(null);
    const roundTypes = ["All", "Tournament", "Qualifying", "Practice"]
    const [tournamentSelected, setTournamentSelected] = useState(false);
    const [seeAllPlayers, setSeeAllPlayers] = useState(true);
    const [playersSelectedStats, setPlayersSelectedStats] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [progressValue, setProgressValue] = useState(0)

    async function getRounds() {
        setLoading(true);
        if (selectedUsers.length > 0 && startDate && endDate && roundType) {
            setProgressValue(0);
            const fetchPromises = [];
            const jwt = await getJWT();
            let count = 0;
            selectedUsers.forEach(function (p) {
                const fetchPromise = fetch(`/api/round/number-rounds?start=${startDate.toISOString().substring(0, 10)}&end=${endDate.toISOString().substring(0, 10)}&userId=${p.userId}&roundType=${roundType}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${jwt}`
                    }
                })
                    .then(response => response.json())
                    .then(data => {
                        p.roundCount = data;
                        count += 100 / selectedUsers.length;
                        setProgressValue(Math.round(count))
                        fetchPromises.push(fetchPromise);
                    })
                    .catch(error => console.error(error));

            });
            Promise.all(fetchPromises)
                .then(() => {
                    const updatedUserAccounts = [...selectedUsers];
                    setSelectedUsers(updatedUserAccounts);
                    setLoading(false);
                })
                .catch(error => { console.error(error); setLoading(false) });
        }
    }

    useEffect(() => {
        getRounds();
    }, [startDate, endDate, roundType])




    const valueTemplate = (value) => {
        return (
            <React.Fragment>
                {Math.round(value / selectedUsers.length)}/<b>{selectedUsers.length}</b>
            </React.Fragment>
        );
    };
    return (

        <div>
            {!loading && <ProgressBar displayValueTemplate={valueTemplate} value={progressValue} className='mb-4'></ProgressBar>}
            {seeAllPlayers ?
                <div>
                    <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                        <label htmlFor='startLabel'>Start Date</label>
                        <DateInput id="startLabel" setSelectedDate={setStartDate} selectedDate={startDate} />
                        <label htmlFor='endLabel'>End Date</label>
                        <DateInput id="endLabel" setSelectedDate={setEndDate} selectedDate={endDate} />
                        <RoundTypeDropdown setTournamentSelected={setTournamentSelected} setRoundType={setRoundType} roundType={roundType} roundTypes={roundTypes} />
                    </div>
                    <div className='mt-4'>
                        <MultiSelectPlayers selectedUsers={selectedUsers} setSelectedUsers={setSelectedUsers} />

                    </div>

                    <Card className='mt-4 mb-4'>
                        <Table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Number of Rounds</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {selectedUsers.length > 0 && selectedUsers.map(p => (
                                    <tr>
                                        <td>{p.userName}</td>
                                        <td>{p.roundCount}</td>
                                        <td><Button size='small' label='See Rounds' severity='secondary'
                                            onClick={() => { setSeeAllPlayers(false); setPlayersSelectedStats(p) }} /></td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </Card>
                </div>
                :
                <div>
                    <Button label='Go back' onClick={() => setSeeAllPlayers(true)} className='mb-6' />
                    <RoundTable className="mt-5" userId={playersSelectedStats.userId.substring(playersSelectedStats.userId.indexOf('|') + 1)} />
                </div>}
        </div>
    )
}

export { ToDateRounds }